import React, { Component } from 'react';
import moment from 'moment';
import Modal from './Modal';
// React Notification
import { NotificationManager } from 'react-notifications';
import axiosInstance from '../../redux/axiosInstance';
import Pagination from 'react-js-pagination';
import { CSVLink } from "react-csv";

// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Input
} from 'reactstrap';
// core components

import Header from 'components/Headers/Header.js';
import UserService from './UserService';

import LoadingShow from '../../components/LoadingShow';

export default class ListUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      error: null,
      users: [],
      userData: {},
      response: {},
      activePage: 1,
      itemsCountPerPage: 1,
      totalItemsCount: 1,
      pageRangeDisplayed: 3,
      search: '',
      loading: false
    };
    this.deactivateUser = this.deactivateUser.bind(this);
    this.activateUser = this.activateUser.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
    this.updateLifecycleStatus = this.updateLifecycleStatus.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
  }

  deactivateUser(id) {
    UserService.deactivateUser(id).then((res) => {
      this.setState({
        users: this.state.users.filter((user) => user.id !== id)
      });
      NotificationManager.success(
        'User deactivated successfully !',
        'Success!',
        2000
      );
      window.setTimeout(function () {
        window.location.reload();
      }, 700);
    });
  }

  activateUser(id) {
    UserService.activateUser(id).then((res) => {
      this.setState({
        users: this.state.users.filter((user) => user.id !== id)
      });
      NotificationManager.success(
        'User activated successfully !',
        'Success!',
        2000
      );
      window.setTimeout(function () {
        window.location.reload();
      }, 700);
    });
  }

  updateLifecycleStatus(userId, status) {
    UserService.updateLifecycleStatus(userId, status).then(() => {
      this.setState({
        users: this.state.users.map((u) =>
          u._id === userId ? { ...u, lifecycle_status: status } : u
        )
      });
      NotificationManager.success(
        `Status updated to "${status}"`,
        'Success!',
        2000
      );
    }).catch(() => {
      NotificationManager.error('Failed to update status', 'Error', 2000);
    });
  }

  toggleModal(user) {
    this.setState({
      userData: user || {},
      isOpen: !this.state.isOpen
    });
  }

  componentDidMount() {
    this.setState({ loading: true });
    axiosInstance
      .get('/admin/user/list')
      .then((response) => {
        this.setState({
          users: response.data.data,
          itemsCountPerPage: response.data.perPage,
          totalItemsCount: response.data.totalData,
          activePage: response.data.currentPage || 1,
          loading: false
        });
      })
      .catch((e) => this.setState({ loading: false }));

      axiosInstance.get('/admin/user/list/all/users').then(res => {
        this.setState({
          allUsers: res?.data?.data
        })
      })
  }

  handlePageChange(pageNumber) {
    this.setState({
      activePage: pageNumber,
      loading: true
    });
    var query = `/admin/user/list?page=${pageNumber}`

    axiosInstance
      .get(query)
      .then((response) => {
        this.setState({
          users: response.data.data,
          itemsCountPerPage: response.data.perPage,
          totalItemsCount: response.data.totalData,
          activePage: response.data.currentPage,
          loading: false
        });
      })
      .catch((e) => this.setState({ loading: false }));
  }

  handleSearchChange(e) {
    var search = e.target.value;
    this.setState({
      search: search,
      loading: true
    });
    var query = search === '' ? `/admin/user/list` : `/admin/user/list?search=${search}`;

    axiosInstance
      .get(query)
      .then((response) => {
        this.setState({
          users: response.data.data,
          itemsCountPerPage: response.data.perPage,
          totalItemsCount: response.data.totalData,
          activePage: response.data.currentPage || 1,
          loading: false
        });
      })
      .catch((e) => this.setState({ loading: false }));
  }

  render() {

    const headers = [
      { label: "First Name", key: "first_name" },
      { label: "Last Name", key: "last_name" },
      { label: "Phone", key: "phone" },
      { label: "Email", key: "email" },
      { label: "Activated", key: "activated" },
      
    ];
    return (
      <>
        <Header />
        {/* Page content */}
        <Container className="mt--7" fluid>
          {/* Table */}
          <Row>
            <div className="col">
              <Card className="shadow">
                {/* <CardHeader className="border-0">
                  <a className="mb-0" href="/admin/user/upload">Upload New user</a>
                </CardHeader> */}
                <CardHeader className="border-0">
                  <div className="d-flex align-items-center justify-content-between">
                    <h3 className="mb-0">List of users</h3>
                    <div className="d-flex align-items-center" style={{ gap: '1rem' }}>
                      <Input
                        type="text"
                        placeholder="Search by name, email or phone..."
                        value={this.state.search}
                        onChange={this.handleSearchChange}
                        style={{ width: '280px' }}
                      />
                      {this.state.allUsers &&
                        <CSVLink data={this.state.allUsers} filename={`users-list`} headers={headers}>{`Export-Users-List`}</CSVLink>
                      }
                    </div>
                  </div>
                </CardHeader>

                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">ID</th>
                      <th scope="col">First Name</th>
                      <th scope="col">Last Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Last Login</th>
                      <th scope="col">Status</th>
                      <th scope="col">Lifecycle Status</th>
                      <th scope="col" />
                    </tr>
                  </thead>
                  <tbody>
                    {!this.state.loading ? (
                      this.state.users.length === 0 ? (
                        <tr
                          dangerouslySetInnerHTML={{
                            __html: LoadingShow('No result found ', '7')
                          }}
                        />
                      ) : (
                        this.state.users.map((user) => {
                          return (
                            <tr key={user.id}>
                              <td>
                                {' '}
                                {user._id}
                              </td>

                              <td>{user.first_name}</td>
                              <td>{user.last_name}</td>
                              <td>{user.email}</td>
                              <td>{moment(user.createdAt).fromNow()}</td>
                              {user.isActive ? (
                                <td>
                                  <Badge color="success">Active</Badge>
                                </td>
                              ) : (
                                <td>
                                  <Badge color="danger">Deactivated</Badge>
                                </td>
                              )}
                              <td>{user.lifecycle_status}</td>

                              <td>
                                {user.lifecycle_status ? (
                                  <Badge color={
                                    user.lifecycle_status === 'published' ? 'success' :
                                    user.lifecycle_status === 'professionally_verified' ? 'info' :
                                    user.lifecycle_status === 'submitted_for_review' ? 'warning' :
                                    user.lifecycle_status === 'onboarding_in_progress' ? 'primary' :
                                    'secondary'
                                  }>
                                    {user.lifecycle_status.replace(/_/g, ' ')}
                                  </Badge>
                                ) : (
                                  <Badge color="secondary">account created</Badge>
                                )}
                              </td>

                              <td className="text-right">
                                <UncontrolledDropdown>
                                  <DropdownToggle
                                    className="btn-icon-only text-light"
                                    href="#!"
                                    role="button"
                                    size="sm"
                                    color=""
                                    onClick={(e) => e.preventDefault()}
                                  >
                                    <i className="fas fa-ellipsis-v" />
                                  </DropdownToggle>
                                  <DropdownMenu
                                    className="dropdown-menu-arrow"
                                    right
                                  >
                                    <DropdownItem
                                      href="#!"
                                      onClick={() => this.toggleModal(user)}
                                    >
                                      View
                                    </DropdownItem>
                                    {user.is_activated === 1 ? (
                                      <DropdownItem
                                        href="#!"
                                        onClick={() =>
                                          this.deactivateUser(user.id)
                                        }
                                      >
                                        Deactivate
                                      </DropdownItem>
                                    ) : (
                                      <DropdownItem
                                        href="#!"
                                        onClick={() =>
                                          this.activateUser(user.id)
                                        }
                                      >
                                        Activate
                                      </DropdownItem>
                                    )}
                                    {user.lifecycle_status === 'submitted_for_review' && (
                                      <DropdownItem
                                        href="#!"
                                        onClick={() =>
                                          this.updateLifecycleStatus(user._id, 'professionally_verified')
                                        }
                                      >
                                        Verify Professionally
                                      </DropdownItem>
                                    )}
                                    {user.lifecycle_status === 'professionally_verified' && (
                                      <DropdownItem
                                        href="#!"
                                        onClick={() =>
                                          this.updateLifecycleStatus(user._id, 'published')
                                        }
                                      >
                                        Publish Profile
                                      </DropdownItem>
                                    )}
                                  </DropdownMenu>
                                </UncontrolledDropdown>
                              </td>
                            </tr>
                          );
                        })
                      )
                    ) : (
                      <tr
                        dangerouslySetInnerHTML={{
                          __html: LoadingShow('Loading...', '7')
                        }}
                      />
                    )}
                  </tbody>
                </Table>
                <Modal
                  show={this.state.isOpen}
                  onClose={() => this.toggleModal(null)}
                >
                  <Table className="table">
                    <thead>
                      <tr className="btn-primary">
                        <th colSpan="2">User Details</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <th>First Name</th>
                        <td>{this.state.userData.first_name}</td>
                      </tr>
                      <tr>
                        <th>Last Name</th>
                        <td>{this.state.userData.last_name}</td>
                      </tr>
                      <tr>
                        <th>Email</th>
                        <td>{this.state.userData.email}</td>
                      </tr>
                      <tr>
                        <th>Phone</th>
                        <td>{this.state.userData.phone}</td>
                      </tr>
                      <tr>
                        <th>Lifecycle Status</th>
                        <td>{this.state.userData.lifecycle_status}</td>
                      </tr>
                      <tr>
                        <th>Status</th>
                        <td>{this.state.userData.isActive ? 'Active' : 'Deactivated'}</td>
                      </tr>
                      <tr>
                        <th>Approved</th>
                        <td>{this.state.userData.approved ? 'Yes' : 'No'}</td>
                      </tr>
                      <tr>
                        <th>Joined</th>
                        <td>{this.state.userData.createdAt ? moment(this.state.userData.createdAt).format('MMM D, YYYY') : ''}</td>
                      </tr>
                    </tbody>
                  </Table>
                </Modal>
                <CardFooter className="py-4">
                  <nav aria-label="...">
                    <Pagination
                      activePage={this.state.activePage}
                      itemsCountPerPage={this.state.itemsCountPerPage}
                      totalItemsCount={this.state.totalItemsCount}
                      pageRangeDisplayed={this.state.pageRangeDisplayed}
                      onChange={this.handlePageChange}
                      itemClass="page-item"
                      linkClass="page-link"
                    />
                  </nav>
                </CardFooter>
              </Card>
            </div>
          </Row>
        </Container>
      </>
    );
  }
}
